import { create } from 'zustand'

import type { Project } from '@/modules/projects'

// The project page's own store lives inside that page, out of the bar's reach.
// The page reports its project here so the bar can follow it.
interface OpenProjectState {
  project: Project | null
  setProject: (project: Project | null) => void
}

export const useOpenProjectStore = create<OpenProjectState>((set) => ({
  project: null,
  setProject: (project) => set({ project }),
}))
